// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==================== SHARED FEED CONTAINER ==================== */

.uash-shared-feed-container {
  position: relative;
  width: 98%;
  height: auto;
  padding: 1rem;
  box-sizing: border-box;
  max-width: 1500px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 2rem;
  border-radius: 10px;
  background: rgb(34, 31, 31);
  margin-bottom: 3rem;
  overflow: visible;
  background: var(--card-bg, rgb(4, 4, 4));
  border: 1px solid var(--border-color, rgb(52, 51, 51));
  margin-left: 5px;
}

/* ==================== POST WRAPPER ==================== */

.uash-post-wrapper {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 0;
  margin-bottom: 1.5rem;
}

/* ==================== HEADER SECTION (BLACK BACKGROUND) ==================== */

.uash-post-header-section {
  width: 100%;
  background: #000;
  border-radius: 10px 10px 0 0;
  padding: 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  border-bottom: none;
}

/* ==================== USER INFO WRAPPER ==================== */

.uash-user-info-wrapper {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 0.75rem;
  width: 100%;
}

.uash-user-avatar-wrapper {
  width: 50px;
  height: 50px;
  flex-shrink: 0;
  border-radius: 50%;
  overflow: hidden;
}

.uash-user-details {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

/* ==================== USER NAME ROW WITH INLINE PLATFORMS ==================== */

.uash-user-name-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.5rem;
  flex-wrap: wrap;
}

.uash-user-name-link {
  text-decoration: none;
  color: white;
  transition: color 0.3s ease;
}

.uash-user-name-link:hover {
  color: #4a9eff;
}

/* ==================== COMMA SEPARATOR ==================== */

.uash-comma-separator {
  color: rgba(255, 255, 255, 0.6);
  font-size: 1rem;
  font-weight: 400;
  margin: 0 0.25rem;
}

/* ==================== INLINE PLATFORMS ==================== */

.uash-inline-platforms {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  align-items: center;
}

/* ==================== INLINE PLATFORM BADGE (COLOR-CODED) ==================== */

.uash-platform-badge-inline {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.35rem 0.75rem;
  border-radius: 20px;
  border: 1.5px solid;
  font-size: 0.75rem;
  font-weight: 700;
  transition: all 0.3s ease;
  cursor: default;
  position: relative;
  overflow: hidden;
}

.uash-platform-badge-inline::before {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.1);
  transition: left 0.4s ease;
}

.uash-platform-badge-inline:hover::before {
  left: 100%;
}

.uash-platform-badge-inline:hover {
  transform: translateY(-2px) scale(1.05);
}

.uash-platform-icon-inline {
  font-size: 1rem;
  line-height: 1;
  filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.3));
}

.uash-platform-name-inline {
  font-weight: 700;
  letter-spacing: 0.3px;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.4);
}

/* ==================== TIMESTAMP ROW ==================== */

.uash-timestamp-row {
  display: flex;
  align-items: center;
  width: 100%;
}

.uash-timestamp {
  color: rgba(255, 255, 255, 0.6);
  font-size: 0.875rem;
  font-weight: 400;
}

/* ==================== SHARED FEED CARD ==================== */

.uash-shared-feed-card {
  width: 100%;
  height: auto;
  border-radius: 0 0 10px 10px;
  background: none;
  box-shadow: 1px 2px 1px rgba(0, 0, 0, 0.1);
  border-top: none;
  padding: 1rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

/* ==================== POST DESCRIPTION ==================== */

.uash-post-description {
  width: 100%;
  padding: 0.5rem;
}

.uash-post-description .text-label {
  color: white;
  line-height: 1.6;
  font-size: 1rem;
}

/* ==================== SHARED FEED MEDIA ==================== */

.uash-shared-feed-media {
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
}

.uash-shared-media-container {
  width: 100%;
  height: auto;
  border-radius: 12px;
  overflow: hidden;
}

.shared-media-img {
  width: 100%;
  height: auto;
  border-radius: 8px;
  object-fit: cover;
}

/* ==================== POST FOOTER ==================== */

.uash-post-footer {
  width: 100%;
  padding: 0.75rem;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  margin-top: 0.5rem;
}

.uash-footer-stats {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  flex-wrap: wrap;
}

.uash-likes-count {
  color: rgba(255, 255, 255, 0.8);
  font-size: 0.9rem;
  font-weight: 500;
}

.uash-separator {
  color: rgba(255, 255, 255, 0.4);
  font-size: 0.9rem;
}

.uash-location-link {
  color: #4a9eff;
  text-decoration: none;
  font-size: 0.9rem;
  font-weight: 500;
  transition: color 0.3s ease;
}

.uash-location-link:hover {
  color: #74b9ff;
  text-decoration: underline;
}

/* ==================== LOADING & EMPTY STATES ==================== */

.uash-loading {
  width: 100%;
  padding: 3rem;
  text-align: center;
  color: rgba(255, 255, 255, 0.6);
}

.uash-no-posts {
  width: 100%;
  padding: 3rem;
  text-align: center;
  color: rgba(255, 255, 255, 0.5);
  font-style: italic;
}

/* ==================== RESPONSIVE: TABLET ==================== */

@media (max-width: 1024px) {
  .uash-shared-feed-container {
    padding: 0.75rem;
    gap: 1.5rem;
  }

  .uash-post-header-section {
    padding: 0.875rem;
  }

  .uash-shared-feed-card {
    padding: 0.875rem;
  }

  .uash-platform-badge-inline {
    padding: 0.3rem 0.65rem;
    font-size: 0.7rem;
  }

  .uash-platform-icon-inline {
    font-size: 0.95rem;
  }
}

@media (max-width: 768px) {
  .uash-shared-feed-container {
    padding: 0.5rem;
    gap: 1rem;
    margin-bottom: 2rem;
  }

  .uash-post-header-section {
    padding: 0.75rem;
  }

  .uash-user-info-wrapper {
    flex-direction: row;
    align-items: flex-start;
  }

  .uash-user-name-row {
    gap: 0.4rem;
  }

  .uash-inline-platforms {
    gap: 0.4rem;
  }

  .uash-platform-badge-inline {
    padding: 0.28rem 0.6rem;
    font-size: 0.68rem;
    gap: 0.3rem;
  }

  .uash-platform-icon-inline {
    font-size: 0.9rem;
  }

  .uash-shared-feed-card {
    padding: 0.75rem;
  }

  .uash-timestamp {
    font-size: 0.8rem;
  }

  .uash-post-description .text-label {
    font-size: 0.9rem;
  }
}

/* ==================== RESPONSIVE: MOBILE ==================== */

@media (max-width: 480px) {
  .uash-shared-feed-container {
    padding: 0.5rem;
    gap: 0.75rem;
    margin-bottom: 1.5rem;
  }

  .uash-post-wrapper {
    margin-bottom: 1rem;
  }

  .uash-post-header-section {
    padding: 0.5rem;
  }

  .uash-user-avatar-wrapper {
    width: 40px;
    height: 40px;
  }

  .uash-user-name-row {
    gap: 0.35rem;
  }

  .uash-inline-platforms {
    gap: 0.35rem;
  }

  .uash-platform-badge-inline {
    padding: 0.25rem 0.5rem;
    font-size: 0.65rem;
    gap: 0.25rem;
  }

  .uash-platform-icon-inline {
    font-size: 0.85rem;
  }

  .uash-comma-separator {
    font-size: 0.9rem;
  }

  .uash-shared-feed-card {
    padding: 0.5rem;
  }

  .uash-post-description {
    padding: 0.25rem;
  }

  .uash-post-description .text-label {
    font-size: 0.85rem;
  }

  .uash-timestamp {
    font-size: 0.75rem;
  }

  .uash-likes-count,
  .uash-location-link {
    font-size: 0.85rem;
  }

  .uash-footer-stats {
    gap: 0.5rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Pages/AccountPage/Styles/UASharedContent.css"],"names":[],"mappings":"AAAA,oEAAoE;;AAEpE;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,2BAA2B;EAC3B,SAAS;EACT,mBAAmB;EACnB,2BAA2B;EAC3B,mBAAmB;EACnB,iBAAiB;EACjB,wCAAwC;EACxC,sDAAsD;EACtD,gBAAgB;AAClB;;AAEA,2DAA2D;;AAE3D;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,MAAM;EACN,qBAAqB;AACvB;;AAEA,gFAAgF;;AAEhF;EACE,WAAW;EACX,gBAAgB;EAChB,4BAA4B;EAC5B,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,mBAAmB;AACrB;;AAEA,gEAAgE;;AAEhE;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA,kFAAkF;;AAElF;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA,8DAA8D;;AAE9D;EACE,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,+DAA+D;;AAE/D;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA,kFAAkF;;AAElF;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,wBAAwB;EACxB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,0BAA0B;AAC5B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iDAAiD;AACnD;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA,4DAA4D;;AAE5D;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,+DAA+D;;AAE/D;EACE,WAAW;EACX,YAAY;EACZ,4BAA4B;EAC5B,gBAAgB;EAChB,0CAA0C;EAC1C,gBAAgB;EAChB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,+DAA+D;;AAE/D;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;;AAEA,gEAAgE;;AAEhE;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,0DAA0D;;AAE1D;EACE,WAAW;EACX,gBAAgB;EAChB,8CAA8C;EAC9C,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,+BAA+B;EAC/B,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA,qEAAqE;;AAErE;EACE,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA,iEAAiE;;AAEjE;EACE;IACE,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,uBAAuB;IACvB,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,eAAe;IACf,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,uBAAuB;IACvB,kBAAkB;IAClB,WAAW;EACb;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA,iEAAiE;;AAEjE;EACE;IACE,eAAe;IACf,YAAY;IACZ,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,uBAAuB;IACvB,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;;IAEE,kBAAkB;EACpB;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":["/* ==================== SHARED FEED CONTAINER ==================== */\n\n.uash-shared-feed-container {\n  position: relative;\n  width: 98%;\n  height: auto;\n  padding: 1rem;\n  box-sizing: border-box;\n  max-width: 1500px;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: flex-start;\n  gap: 2rem;\n  border-radius: 10px;\n  background: rgb(34, 31, 31);\n  margin-bottom: 3rem;\n  overflow: visible;\n  background: var(--card-bg, rgb(4, 4, 4));\n  border: 1px solid var(--border-color, rgb(52, 51, 51));\n  margin-left: 5px;\n}\n\n/* ==================== POST WRAPPER ==================== */\n\n.uash-post-wrapper {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n  margin-bottom: 1.5rem;\n}\n\n/* ==================== HEADER SECTION (BLACK BACKGROUND) ==================== */\n\n.uash-post-header-section {\n  width: 100%;\n  background: #000;\n  border-radius: 10px 10px 0 0;\n  padding: 1rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  border-bottom: none;\n}\n\n/* ==================== USER INFO WRAPPER ==================== */\n\n.uash-user-info-wrapper {\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  gap: 0.75rem;\n  width: 100%;\n}\n\n.uash-user-avatar-wrapper {\n  width: 50px;\n  height: 50px;\n  flex-shrink: 0;\n  border-radius: 50%;\n  overflow: hidden;\n}\n\n.uash-user-details {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n/* ==================== USER NAME ROW WITH INLINE PLATFORMS ==================== */\n\n.uash-user-name-row {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 0.5rem;\n  flex-wrap: wrap;\n}\n\n.uash-user-name-link {\n  text-decoration: none;\n  color: white;\n  transition: color 0.3s ease;\n}\n\n.uash-user-name-link:hover {\n  color: #4a9eff;\n}\n\n/* ==================== COMMA SEPARATOR ==================== */\n\n.uash-comma-separator {\n  color: rgba(255, 255, 255, 0.6);\n  font-size: 1rem;\n  font-weight: 400;\n  margin: 0 0.25rem;\n}\n\n/* ==================== INLINE PLATFORMS ==================== */\n\n.uash-inline-platforms {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n  align-items: center;\n}\n\n/* ==================== INLINE PLATFORM BADGE (COLOR-CODED) ==================== */\n\n.uash-platform-badge-inline {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.4rem;\n  padding: 0.35rem 0.75rem;\n  border-radius: 20px;\n  border: 1.5px solid;\n  font-size: 0.75rem;\n  font-weight: 700;\n  transition: all 0.3s ease;\n  cursor: default;\n  position: relative;\n  overflow: hidden;\n}\n\n.uash-platform-badge-inline::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: -100%;\n  width: 100%;\n  height: 100%;\n  background: rgba(255, 255, 255, 0.1);\n  transition: left 0.4s ease;\n}\n\n.uash-platform-badge-inline:hover::before {\n  left: 100%;\n}\n\n.uash-platform-badge-inline:hover {\n  transform: translateY(-2px) scale(1.05);\n}\n\n.uash-platform-icon-inline {\n  font-size: 1rem;\n  line-height: 1;\n  filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.3));\n}\n\n.uash-platform-name-inline {\n  font-weight: 700;\n  letter-spacing: 0.3px;\n  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.4);\n}\n\n/* ==================== TIMESTAMP ROW ==================== */\n\n.uash-timestamp-row {\n  display: flex;\n  align-items: center;\n  width: 100%;\n}\n\n.uash-timestamp {\n  color: rgba(255, 255, 255, 0.6);\n  font-size: 0.875rem;\n  font-weight: 400;\n}\n\n/* ==================== SHARED FEED CARD ==================== */\n\n.uash-shared-feed-card {\n  width: 100%;\n  height: auto;\n  border-radius: 0 0 10px 10px;\n  background: none;\n  box-shadow: 1px 2px 1px rgba(0, 0, 0, 0.1);\n  border-top: none;\n  padding: 1rem;\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n/* ==================== POST DESCRIPTION ==================== */\n\n.uash-post-description {\n  width: 100%;\n  padding: 0.5rem;\n}\n\n.uash-post-description .text-label {\n  color: white;\n  line-height: 1.6;\n  font-size: 1rem;\n}\n\n/* ==================== SHARED FEED MEDIA ==================== */\n\n.uash-shared-feed-media {\n  width: 100%;\n  height: auto;\n  display: flex;\n  flex-direction: column;\n}\n\n.uash-shared-media-container {\n  width: 100%;\n  height: auto;\n  border-radius: 12px;\n  overflow: hidden;\n}\n\n.shared-media-img {\n  width: 100%;\n  height: auto;\n  border-radius: 8px;\n  object-fit: cover;\n}\n\n/* ==================== POST FOOTER ==================== */\n\n.uash-post-footer {\n  width: 100%;\n  padding: 0.75rem;\n  border-top: 1px solid rgba(255, 255, 255, 0.1);\n  margin-top: 0.5rem;\n}\n\n.uash-footer-stats {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  flex-wrap: wrap;\n}\n\n.uash-likes-count {\n  color: rgba(255, 255, 255, 0.8);\n  font-size: 0.9rem;\n  font-weight: 500;\n}\n\n.uash-separator {\n  color: rgba(255, 255, 255, 0.4);\n  font-size: 0.9rem;\n}\n\n.uash-location-link {\n  color: #4a9eff;\n  text-decoration: none;\n  font-size: 0.9rem;\n  font-weight: 500;\n  transition: color 0.3s ease;\n}\n\n.uash-location-link:hover {\n  color: #74b9ff;\n  text-decoration: underline;\n}\n\n/* ==================== LOADING & EMPTY STATES ==================== */\n\n.uash-loading {\n  width: 100%;\n  padding: 3rem;\n  text-align: center;\n  color: rgba(255, 255, 255, 0.6);\n}\n\n.uash-no-posts {\n  width: 100%;\n  padding: 3rem;\n  text-align: center;\n  color: rgba(255, 255, 255, 0.5);\n  font-style: italic;\n}\n\n/* ==================== RESPONSIVE: TABLET ==================== */\n\n@media (max-width: 1024px) {\n  .uash-shared-feed-container {\n    padding: 0.75rem;\n    gap: 1.5rem;\n  }\n\n  .uash-post-header-section {\n    padding: 0.875rem;\n  }\n\n  .uash-shared-feed-card {\n    padding: 0.875rem;\n  }\n\n  .uash-platform-badge-inline {\n    padding: 0.3rem 0.65rem;\n    font-size: 0.7rem;\n  }\n\n  .uash-platform-icon-inline {\n    font-size: 0.95rem;\n  }\n}\n\n@media (max-width: 768px) {\n  .uash-shared-feed-container {\n    padding: 0.5rem;\n    gap: 1rem;\n    margin-bottom: 2rem;\n  }\n\n  .uash-post-header-section {\n    padding: 0.75rem;\n  }\n\n  .uash-user-info-wrapper {\n    flex-direction: row;\n    align-items: flex-start;\n  }\n\n  .uash-user-name-row {\n    gap: 0.4rem;\n  }\n\n  .uash-inline-platforms {\n    gap: 0.4rem;\n  }\n\n  .uash-platform-badge-inline {\n    padding: 0.28rem 0.6rem;\n    font-size: 0.68rem;\n    gap: 0.3rem;\n  }\n\n  .uash-platform-icon-inline {\n    font-size: 0.9rem;\n  }\n\n  .uash-shared-feed-card {\n    padding: 0.75rem;\n  }\n\n  .uash-timestamp {\n    font-size: 0.8rem;\n  }\n\n  .uash-post-description .text-label {\n    font-size: 0.9rem;\n  }\n}\n\n/* ==================== RESPONSIVE: MOBILE ==================== */\n\n@media (max-width: 480px) {\n  .uash-shared-feed-container {\n    padding: 0.5rem;\n    gap: 0.75rem;\n    margin-bottom: 1.5rem;\n  }\n\n  .uash-post-wrapper {\n    margin-bottom: 1rem;\n  }\n\n  .uash-post-header-section {\n    padding: 0.5rem;\n  }\n\n  .uash-user-avatar-wrapper {\n    width: 40px;\n    height: 40px;\n  }\n\n  .uash-user-name-row {\n    gap: 0.35rem;\n  }\n\n  .uash-inline-platforms {\n    gap: 0.35rem;\n  }\n\n  .uash-platform-badge-inline {\n    padding: 0.25rem 0.5rem;\n    font-size: 0.65rem;\n    gap: 0.25rem;\n  }\n\n  .uash-platform-icon-inline {\n    font-size: 0.85rem;\n  }\n\n  .uash-comma-separator {\n    font-size: 0.9rem;\n  }\n\n  .uash-shared-feed-card {\n    padding: 0.5rem;\n  }\n\n  .uash-post-description {\n    padding: 0.25rem;\n  }\n\n  .uash-post-description .text-label {\n    font-size: 0.85rem;\n  }\n\n  .uash-timestamp {\n    font-size: 0.75rem;\n  }\n\n  .uash-likes-count,\n  .uash-location-link {\n    font-size: 0.85rem;\n  }\n\n  .uash-footer-stats {\n    gap: 0.5rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
